interface Iprops {
    style?: any
}
export const Logo = ({ style }: Iprops) => {
    return (
        <div className="logoer">

            <img
                style={style}
                alt="vizag bike rentals"
                src="assets/chalo-ride-logo.png"
            />

        </div>
    )
}

export default Logo;